import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ToggleBookmarkIconButton } from '@/components/ui/Button/ToggleButton/ToggleIconButtons';
/**
 * コンサルサーチ：ブックマーク切り替えボタンコンポーネント
 * @param props
 * @constructor
 */
export const CSearchToggleBookmarkIconButton = (props) => {
    const { boolState, className = '', disabled, isFalseIconColorWhite = false, onClick, size, type, value, } = props;
    return (_jsx(ToggleBookmarkIconButton, { boolState: boolState, className: className, disabled: disabled, falseIconClassName: clsx(!isFalseIconColorWhite && 'text-blue-gray-200', 'hover:text-turquoise-blue-100'), falseIconColor: isFalseIconColorWhite ? 'white' : 'none', onClick: onClick, size: size, trueIconColor: 'info', type: type, value: value }));
};
